import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BotDetectionService {
  constructor() {}

  /**
   * Detects if the current visitor is Googlebot based on the User-Agent string.
   * @returns boolean - True if Googlebot is detected, otherwise false.
   */
  isGooglebot(): boolean {
    const userAgent = navigator.userAgent || '';
    // Check if the User-Agent contains "Googlebot"
    return /Googlebot/i.test(userAgent);
  }

  /**
   * Detects if the current visitor is any bot (optional utility).
   * @returns boolean - True if a bot is detected, otherwise false.
   */
  isAnyBot(): boolean {
    const userAgent = navigator.userAgent || '';
    // Common bot indicators in User-Agent strings
    const botPatterns = /bot|crawl|spider|slurp|googlebot/i;
    return botPatterns.test(userAgent);
  }
}
